import { styled } from "@mui/material/styles";

// Components
import { StyledCard } from "~/components/Common";

// Themes
import theme from "~/components/Common/Theme";

const styledName = "AuthFormLayout";

const AuthFormLayout = styled(StyledCard, { name: styledName })({
  "&": {
    display: "flex",
    flexDirection: "column",
    maxWidth: "480px",
    height: "fit-content",
    backgroundColor: theme.palette.background.default,
  },
});

export default AuthFormLayout;
